import React from 'react';
import {
  StyleSheet,
  View,
  ImageSourcePropType,
  TouchableOpacity,
  StyleProp,
  ViewStyle,
  Text,
} from 'react-native';
import {Typography, Badge} from 'src/components';
import {colors} from 'src/assets';
import {IReview} from 'src/domains';
import {Header, Rating} from './components';

export type ReviewCardProps = {
  containerStyle?: StyleProp<ViewStyle>;
  review: IReview;
  onPress: (review: any) => void;
};

export const ReviewCard: React.FC<ReviewCardProps> = ({
  containerStyle,
  review,
  onPress,
}) => {
  return (
    <TouchableOpacity
      style={[styles.container, containerStyle]}
      onPress={() => onPress(review)}>
      <Header
        image={review.owner?.image ? {uri: review.owner?.image} : undefined}
        name={review.owner?.name}
        createdAt={review.createdAt}
      />
      {review.rate ? (
        <Rating containerStyle={styles.rating} value={review.rate} />
      ) : null}
      {review.comment ? (
        <Text style={styles.text}>{review.comment}</Text>
      ) : null}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.chokuGray12,
    borderRadius: 4,
    padding: 16,
  },
  rating: {
    marginTop: 8,
  },
  text: {
    fontSize: 13,
    marginTop: 16,
    color: '#313131',
  },
});
